export default __webpack_public_path__ + "static/laminas_3-53f86660333b08b4d5640e55a7641523.png";